import { IQuestion, ISurvey } from "./survey.types";

export class Survey implements ISurvey {
  id: string;
  title: string;
  questions: IQuestion[];

  constructor(data: ISurvey) {
    this.id = data.id;
    this.title = data.title;
    this.questions = data.questions;
  }
}
